import React from 'react';
import { Provider } from 'react-redux';
import { Providers } from 'containers/providers';
import { Loader } from 'components/loader/Loader';
import configureStore from './store/configureStore';
import OnlineCheck from './containers/OnlineCheck';

export const store = configureStore();

const AppRouter = React.lazy(() => import('./router'));

function App() {
	return (
		<React.Suspense fallback={<Loader isLoading={true} />}>
			<Provider store={store}>
				<Providers>
					<OnlineCheck>
						<AppRouter />
					</OnlineCheck>
				</Providers>
			</Provider>
		</React.Suspense>
	);
}

export default App;
